import { quoteProducts } from "../utils/productPricing";
import { useOutletContext } from 'react-router-dom';
import { useRef } from 'react';
import paymentApi from '../api/api';
import { money } from '../utils/directPayment';
import React, { useState, useEffect } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import ShippingProductDisplay from "./ShippingProductsDisplay";
import { useLocation, Link, useNavigate, useParams } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { place_order } from "../store/reducers/orderReducer";
import { fetchStoreBySlug } from "../store/reducers/homeReducer";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Checkbox } from "../components/ui/checkbox";
import toast from "react-hot-toast";
import { Globe, MapPin, MessageCircle } from "lucide-react";
import { Package, ScrollText, AlertTriangle } from "lucide-react";
import { formatCurrency, fetchExchangeRates, convertCurrency } from "../utils/currencyUtils";
import axios from "../api/api";
import { normalizeStoreName } from "../utils/storeUtils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";

const Shipping = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [exchangeLoaded, setExchangeLoaded] = useState(false);
  const { userInfo } = useSelector((state) => state.auth);
  const { seller } = useSelector((state) => state.home);
  const location = useLocation();
  const { products = [], price: initialPrice = 0, items: initialItems = 0 } = location.state || {};

  const { storeName: urlStoreName } = useParams();
  const outlet = useOutletContext();
    const isStoreMode = !!urlStoreName || !!outlet?.isStoreMode;
  const storeToPass = urlStoreName || location.state?.fromStore;

  const [res, setRes] = useState(false);
  const [totalShippingCost, setTotalShippingCost] = useState(0);
  const [invalidProducts, setInvalidProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [useDefaultAddress, setUseDefaultAddress] = useState(false);
  const [defaultShippingInfo, setDefaultShippingInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const [state, setState] = useState({
    name: "",
    email: userInfo?.email || "",
    address: "",
    phone: "",
    post: "",
    province: "",
    city: "",
    area: "",
    country: "",
  });

  // Calculate items total and count dynamically to ensure correct currency conversion
  const itemsTotal = products.reduce((acc, shop) => {
    return acc + shop.products.reduce((pAcc, prod) => {
      const { price, discount, currency } = prod.productInfo;
      const finalPrice = discount
        ? price - Math.floor((price * discount) / 100)
        : price;
      return pAcc + convertCurrency(finalPrice * prod.quantity, currencyCode, currency);
    }, 0);
  }, 0);

  const itemsCount = products.reduce((acc, shop) => {
    return acc + shop.products.reduce((pAcc, prod) => pAcc + prod.quantity, 0);
  }, 0);

  console.log(itemsTotal);

  const availableCountries = [
    ...new Set(
      products.flatMap((p) =>
        p.products.flatMap((prod) =>
          prod.productInfo.shippingPrices
            ? Object.keys(prod.productInfo.shippingPrices)
            : []
        )
      )
    ),
  ];

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { data } = await axios.get("/account/get-details", {
          withCredentials: true,
        });

        if (data.shippingDetails && !defaultShippingInfo) {
          setDefaultShippingInfo({
            name: data.shippingDetails.name || "",
            address: data.shippingDetails.address || "",
            phone: data.shippingDetails.phone || "",
            post: data.shippingDetails.postal || "",
            province: data.shippingDetails.province || "",
            city: data.shippingDetails.city || "",
            area: data.shippingDetails.area || "",
            country: data.shippingDetails.country || "",
          });
          // setCurrencyCode(data.currency);
        }
      } catch (error) {
        // Handle error silently
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [defaultShippingInfo]); // Add defaultShippingInfo as a dependency

  useEffect(() => {
    if (state.country) {
      calculateShippingCost(state.country);
    }
  }, [state.country]); // Only run when state.country changes

  useEffect(() => {
    if (invalidProducts.length > 0 && res) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [invalidProducts.length, res]);

  useEffect(() => {
    // Only fetch store if NOT in StoreLayout. StoreLayout handles it otherwise.
    if (storeToPass && !isStoreMode) {
      dispatch(fetchStoreBySlug(storeToPass));
    }
  }, [storeToPass, dispatch, isStoreMode]);

  const calculateShippingCost = (country) => {
    let totalShipping = 0;
    let invalid = [];
    const chargedProducts = new Set();

    products.forEach((shop) => {
      shop.products.forEach((prod) => {
        const shippingPrices = prod.productInfo.shippingPrices || {};
        const shippingCost = shippingPrices[country];

        if (shippingCost !== undefined && shippingCost !== null && shippingCost !== "") {
          const cost = Number(shippingCost);
          if (!chargedProducts.has(prod.productInfo._id)) totalShipping += convertCurrency(cost, currencyCode, prod.productInfo.currency);
          chargedProducts.add(prod.productInfo._id);
        } else {
          invalid.push(prod.productInfo._id);
        }
      });
    });

    setTotalShippingCost(totalShipping);
    setInvalidProducts(invalid);
  };

  const handleDefaultAddressChange = (checked) => {
    setUseDefaultAddress(checked);

    if (checked && defaultShippingInfo) {

      if (!availableCountries.includes(defaultShippingInfo.country)) {
        toast.error("Products cannot be shipped to your default location.");
        return;
      }

      setState(defaultShippingInfo);
    } else {

      setState({
        name: "",
        address: "",
        phone: "",
        post: "",
        province: "",
        city: "",
        area: "",
        country: "",
      });
    }
  };

  useEffect(() => {
    if (useDefaultAddress && defaultShippingInfo) {
      // Sync state with defaultShippingInfo when useDefaultAddress is true
      setState(defaultShippingInfo);
    }
  }, [useDefaultAddress, defaultShippingInfo]);

  useEffect(() => {
    console.log("useDefaultAddress changed:", useDefaultAddress);
  }, [useDefaultAddress]);

  useEffect(() => {
    console.log("State updated:", state);
  }, [state]);

  useEffect(() => {
    console.log("defaultShippingInfo updated:", defaultShippingInfo);
  }, [defaultShippingInfo]);

  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const handleCountryChange = (value) => {
    setState({
      ...state,
      country: value,
    });
  };

  const save = (e) => {
    e.preventDefault();
    const { name, email, address, phone, post, province, city, area, country } = state;

    const emptyFields = [];
    if (!name) emptyFields.push("Name");
    if (!email) emptyFields.push("Email");
    if (!address) emptyFields.push("Address");
    if (!phone) emptyFields.push("Phone");
    if (!post) emptyFields.push("Postal code");
    if (!province) emptyFields.push("Province");
    if (!city) emptyFields.push("City");
    if (!area) emptyFields.push("Area");
    if (!country) emptyFields.push("Country");

    if (emptyFields.length > 0) {
      toast.error("Please fill in all required fields");
      return;
    }

    if (invalidProducts.length === 0) {
      setRes(true);
    } else {
      setShowModal(true);
    }
  };
  useEffect(() => {
    fetchExchangeRates().then(() => setExchangeLoaded(true));
  }, []);
  const [paymentQuote, setPaymentQuote] = useState(null);
  const [quoteError, setQuoteError] = useState('');
  const [placing, setPlacing] = useState(false);
  const [quoteVersion, setQuoteVersion] = useState(0);
  const requestKey = useRef(null);
  const cartSignature = JSON.stringify(quoteProducts(products));
  useEffect(() => {
    let active = true;
    setPaymentQuote(null); setQuoteError('');
    if (!state.country || !products.length) return;
    paymentApi.post('/payment/direct/quote', { products: JSON.parse(cartSignature), country: state.country }).then(({ data }) => {
      if (active) { setPaymentQuote(data); requestKey.current = window.crypto.randomUUID(); }
    }).catch(e => { if (active) setQuoteError(e.response?.data?.error || 'Unable to load transfer totals. Please retry.'); });
    return () => { active = false; };
  }, [cartSignature, state.country, quoteVersion]);
  const placeOrder = async () => {
    if (placing || !paymentQuote) return;
    setPlacing(true);
    try {
      await dispatch(place_order({ quoteToken: paymentQuote.token, shippingInfo: state, checkoutKey: requestKey.current, products, navigate, fromStore: storeToPass })).unwrap();
    } catch (error) { toast.error(String(error)); }
    finally { setPlacing(false); }
  };

  console.log(products)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Theme logic - Only if NOT StoreMode
  const getThemeClass = () => {
    if (isStoreMode) return '';

    const themeSettings = seller?.themeSettings;
    const useCustomTheme = themeSettings?.useCustomTheme;

    // Custom theme always uses light-theme class (defaults to light colors)
    if (useCustomTheme) {
      return 'light-theme';
    }
    if (seller?.shopInfo?.theme === 'light') {
      return 'light-theme';
    }
    if (storeToPass) {
      const normalizedStore = normalizeStoreName(storeToPass);
      const cachedTheme = localStorage.getItem(`store-theme-${normalizedStore}`);
      if (cachedTheme === 'light') return 'light-theme';

      try {
        const cachedSettings = localStorage.getItem(`store-settings-${normalizedStore}`);
        if (cachedSettings) {
          const settings = JSON.parse(cachedSettings);
          if (settings.useCustomTheme) return 'light-theme';
        }
      } catch (e) { }
    }
    return '';
  };
  const themeClass = getThemeClass();

  // Apply theme class to body immediately on render if we have cached theme context
  // Only if NOT StoreMode
  if (!isStoreMode && themeClass === 'light-theme') {
    document.body.classList.add('light-theme');

    // If we have cached custom theme settings, apply them now to prevent flash
    if (storeToPass) {
      try {
        const normalizedStore = normalizeStoreName(storeToPass);
        const cachedSettings = localStorage.getItem(`store-settings-${normalizedStore}`);
        if (cachedSettings) {
          const settings = JSON.parse(cachedSettings);
          if (settings.useCustomTheme) {
            const colors = settings.colors || {};
            const setVar = (name, value) => {
              if (value) document.body.style.setProperty(name, value);
            };
            const getContrastColor = (hexcolor) => {
              if (!hexcolor || hexcolor === 'transparent') return null;
              const hex = hexcolor.replace('#', '');
              const r = parseInt(hex.slice(0, 2), 16);
              const g = parseInt(hex.slice(2, 4), 16);
              const b = parseInt(hex.slice(4, 6), 16);
              const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
              return (yiq >= 128) ? '#000000' : '#ffffff';
            };
            const contrastColor = getContrastColor(colors.background);
            setVar('--store-bg', colors.background);
            setVar('--store-text', contrastColor);
            setVar('--store-icon', contrastColor);
            setVar('--store-button-bg', colors.buttonBg);
            setVar('--store-button-text', colors.buttonText);
            setVar('--store-product-card-bg', colors.productCardBg);
            setVar('--store-header-bg', colors.headerBg);
            setVar('--store-footer-bg', colors.footerBg);
            setVar('--store-border', colors.border);
            if (settings.typography?.fontFamily) {
              const fontFamily = settings.typography.fontFamily;
              const fontId = `google-font-${fontFamily.replace(/\s+/g, '-')}`;
              if (!document.getElementById(fontId)) {
                const link = document.createElement('link');
                link.id = fontId;
                link.rel = 'stylesheet';
                link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
                document.head.appendChild(link);
              }
              setVar('--store-font-family', `"${fontFamily}", sans-serif`);
            }
          }
        }
      } catch (e) {
        console.error("Error applying cached theme:", e);
      }
    }
  }

  // Theme effect - Only if NOT StoreMode
  useEffect(() => {
    if (isStoreMode) return;

    if (seller?.shopInfo && storeToPass) {
      const normalizedStore = normalizeStoreName(storeToPass);
      localStorage.setItem(`store-theme-${normalizedStore}`, seller.shopInfo.theme);
      localStorage.setItem(`store-settings-${normalizedStore}`, JSON.stringify(seller.themeSettings || {}));

      const themeSettings = seller?.themeSettings;
      const useCustomTheme = themeSettings?.useCustomTheme;

      // Apply light-theme class when using custom theme or when theme is 'light'
      if (useCustomTheme || seller.shopInfo.theme === 'light') {
        document.body.classList.add('light-theme');
      } else {
        document.body.classList.remove('light-theme');
      }

      // Apply custom CSS variables when useCustomTheme is true
      if (useCustomTheme && themeSettings) {
        const colors = themeSettings.colors || {};
        const setVar = (name, value) => {
          if (value) document.body.style.setProperty(name, value);
        };

        const getContrastColor = (hexcolor) => {
          if (!hexcolor || hexcolor === 'transparent') return null;
          const hex = hexcolor.replace('#', '');
          const r = parseInt(hex.slice(0, 2), 16);
          const g = parseInt(hex.slice(2, 4), 16);
          const b = parseInt(hex.slice(4, 6), 16);
          const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
          return (yiq >= 128) ? '#000000' : '#ffffff';
        };

        const contrastColor = getContrastColor(colors.background);
        setVar('--store-bg', colors.background);
        setVar('--store-text', contrastColor);
        setVar('--store-icon', contrastColor);
        setVar('--store-button-bg', colors.buttonBg);
        setVar('--store-button-text', colors.buttonText);
        setVar('--store-product-card-bg', colors.productCardBg);
        setVar('--store-header-bg', colors.headerBg);
        setVar('--store-footer-bg', colors.footerBg);
        setVar('--store-input-bg', themeSettings.inputs?.background || colors.inputBg);
        setVar('--store-input-text', themeSettings.inputs?.text || colors.inputText);
        setVar('--store-input-border', themeSettings.inputs?.border || colors.inputBorder);
        setVar('--store-input-focus', themeSettings.inputs?.focusRing || '#000000');
        setVar('--store-input-radius', `${themeSettings.inputs?.radius || 20}px`);
        setVar('--store-select-bg', themeSettings.selects?.background || colors.inputBg);
        setVar('--store-select-text', themeSettings.selects?.text || colors.inputText);
        setVar('--store-select-border', themeSettings.selects?.border || colors.inputBorder);
        setVar('--store-select-focus', themeSettings.selects?.focusRing || '#000000');
        setVar('--store-select-radius', `${themeSettings.selects?.radius || 20}px`);
        setVar('--store-border', colors.border);
        setVar('--store-muted', colors.muted);
        setVar('--store-glass', colors.glass);

        // Load and apply Google Font
        if (themeSettings.typography?.fontFamily) {
          const fontFamily = themeSettings.typography.fontFamily;
          const fontId = `google-font-${fontFamily.replace(/\s+/g, '-')}`;

          if (!document.getElementById(fontId)) {
            const link = document.createElement('link');
            link.id = fontId;
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
            document.head.appendChild(link);
          }

          setVar('--store-font-family', `"${fontFamily}", sans-serif`);
          document.body.style.fontFamily = `"${fontFamily}", sans-serif`;
        }
      }
    }

    // Cleanup when unmounting or changing stores
    return () => {
      document.body.classList.remove('light-theme');
    };
  }, [seller, storeToPass, isStoreMode]);

  return (
    <div className={`min-h-screen bg-[var(--store-bg)] transition-colors duration-300 ${!isStoreMode ? themeClass : ''}`}>
      {!isStoreMode && <Headers />}
      <section
        className="h-[220px] bg-cover bg-no-repeat relative bg-left bg-[var(--store-bg)]"
        style={{
          backgroundImage: themeClass === 'light-theme' ? 'none' : `url(${process.env.REACT_APP_URL}/images/banner/cartnew.jpg)`,
        }}
      >
        <div className={`absolute left-0 top-0 w-full h-full transition-colors duration-500 ${themeClass === 'light-theme' ? 'bg-[#0000004d]' : 'bg-[#0000008a]'}`}>
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Stores</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to={location.state?.fromStore ? `/${location.state.fromStore}` : "/"}>Home</Link>
                <span className="pt-2">
                  <MdOutlineKeyboardArrowRight />
                </span>
                <span>Shipping</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[var(--store-bg)]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90] mx-auto py-16">
          <div className="w-full flex flex-wrap">
            <div className="w-[67%] md-lg:w-full">
              <div className="flex flex-col gap-3">
                <div className="bg-[var(--store-product-card-bg)] p-6 shadow-sm rounded-md">
                  {!res && (
                    <>
                      <h2 className="text-xl font-bold flex items-center pb-3 text-[var(--store-text)]">
                        Shipping Information
                      </h2>
                      {!loading && defaultShippingInfo && (
                        <div className="flex items-center space-x-2 mb-4">
                          <Checkbox
                            id="useDefault"
                            checked={useDefaultAddress}
                            onCheckedChange={handleDefaultAddressChange}
                            disabled={!defaultShippingInfo} // Disable if defaultShippingInfo is not available
                          />
                          <label
                            htmlFor="useDefault"
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-[var(--store-text)]"
                          >
                            Use my default shipping address
                          </label>
                        </div>
                      )}
                      <div className="flex gap-4 p-4 bg-blue-500/10 text-blue-500 rounded-lg border border-blue-500/20 mb-4">
                        <Globe className="h-5 w-5 flex-shrink-0 mt-1" />
                        <div className="space-y-3">
                          <p className="text-sm">
                            Important information about shipping availability:
                          </p>
                          <ul className="text-sm space-y-2">
                            <li className="flex items-start gap-2">
                              <MapPin className="h-4 w-4 flex-shrink-0 mt-0.5" />
                              The countries you see in the dropdown are the only
                              ones where merchants have established shipping
                              routes for their products in your cart.
                            </li>
                            <li className="flex items-start gap-2">
                              <MapPin className="h-4 w-4 flex-shrink-0 mt-0.5" />
                              If you don't see your desired destination country,
                              this means the merchants currently don't ship to
                              that location.
                            </li>
                            <li className="flex items-start gap-2">
                              <MessageCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
                              Please contact the merchant directly to inquire
                              about additional shipping options or potential
                              solutions for your desired destination.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <form
                        onSubmit={save}
                        className="flex flex-col gap-2 mt-5"
                      >
                        <div className="flex md:flex-col md:gap-2 w-full gap-5">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="name" className="text-[var(--store-text)]">
                              Name
                            </Label>
                            <Input
                              onChange={inputHandle}
                              value={state.name}
                              type="text"
                              className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                              name="name"
                              placeholder="Name"
                              id="name"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="country" className="text-[var(--store-text)]">
                              Country
                            </Label>
                            <Select
                              onValueChange={handleCountryChange}
                              value={state.country}
                            >
                              <SelectTrigger className="w-full mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] h-10 focus-visible:border-foreground border-[var(--store-input-border)] rounded-lg">
                                <SelectValue placeholder="Select country" />
                              </SelectTrigger>
                              <SelectContent className="bg-[var(--store-card-bg)] border-[var(--store-border)] text-[var(--store-text)]">
                                {availableCountries.map((country) => (
                                  <SelectItem key={country} value={country} className="hover:text-[var(--store-text)] cursor-pointer text-[var(--store-text)]">
                                    {country}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </div>
                        </div>

                        {(
                          <div className="flex md:flex-col md:gap-2 w-full gap-5">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <Label htmlFor="email" className="text-[var(--store-text)]">
                                Email
                              </Label>
                              <Input
                                onChange={inputHandle}
                                value={state.email}
                                type="email"
                                className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                                name="email"
                                placeholder="Email"
                                id="email"
                              />
                            </div>
                          </div>
                        )}

                        <div className="flex md:flex-col md:gap-2 w-full gap-5">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="address" className="text-[var(--store-text)]">
                              Address
                            </Label>
                            <Input
                              onChange={inputHandle}
                              value={state.address}
                              type="text"
                              className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                              name="address"
                              placeholder="House no / building / street / area"
                              id="address"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="phone" className="text-[var(--store-text)]">
                              Phone
                            </Label>
                            <Input
                              onChange={inputHandle}
                              value={state.phone}
                              type="text"
                              className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                              name="phone"
                              placeholder="Phone"
                              id="phone"
                            />
                          </div>
                        </div>

                        <div className="flex md:flex-col md:gap-2 w-full gap-5">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="post" className="text-[var(--store-text)]">
                              Postal code
                            </Label>
                            <Input
                              onChange={inputHandle}
                              value={state.post}
                              type="text"
                              className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                              name="post"
                              placeholder="Postal code"
                              id="post"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="province" className="text-[var(--store-text)]">
                              Province
                            </Label>
                            <Input
                              onChange={inputHandle}
                              value={state.province}
                              type="text"
                              className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                              name="province"
                              placeholder="Province"
                              id="province"
                            />
                          </div>
                        </div>

                        <div className="flex md:flex-col md:gap-2 w-full gap-5">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="city" className="text-[var(--store-text)]">
                              City
                            </Label>
                            <Input
                              onChange={inputHandle}
                              value={state.city}
                              type="text"
                              className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                              name="city"
                              placeholder="City"
                              id="city"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <Label htmlFor="area" className="text-[var(--store-text)]">
                              Area
                            </Label>
                            <Input
                              onChange={inputHandle}
                              value={state.area}
                              type="text"
                              className="w-full px-3 py-2 mt-2 bg-[var(--store-input-bg)] text-[var(--store-input-text)] border-[var(--store-input-border)] placeholder:text-[var(--store-input-text)] placeholder:opacity-50 focus-visible:border-foreground"
                              name="area"
                              placeholder="Area"
                              id="area"
                            />
                          </div>
                        </div>

                        <div className="flex justify-end">
                          <Button
                            type="submit"
                            className="px-5 py-2 rounded-full bg-[var(--store-button-bg)] text-[var(--store-button-text)] hover:bg-[var(--store-button-bg)] hover:opacity-90"
                          >
                            Continue
                          </Button>
                        </div>
                      </form>
                    </>
                  )}
                  {res && (
                    <div className="flex flex-col gap-2">
                      <h2 className="text-[var(--store-text)] font-semibold pb-2">
                        Deliver to {state.name}
                      </h2>
                      <p>
                        <span className="bg-[#FFE11B] text-black text-xs font-bold mr-2 px-4 py-1 rounded">
                          Location
                        </span>
                        <span className="text-[var(--store-text)] text-sm">
                          {state.address} {state.province} {state.city}{" "}
                          {state.area}, {state.country}
                        </span>
                        <span
                          onClick={() => setRes(false)}
                          className="text-[#FFE11B] cursor-pointer ml-2"
                        >
                          change
                        </span>
                      </p>
                    </div>
                  )}
                </div>

                {products.map((p, i) => (
                  <div key={i} className="flex bg-[var(--store-product-card-bg)] p-4 flex-col gap-2">
                    <div className="flex justify-between items-center">
                      <h2 className="text-md text-[var(--store-text)] flex items-center">
                        {p.shopName} <Package size={18} className="ml-2" />
                      </h2>
                      {state.country && (
                        <div className="text-[var(--store-text)] text-sm">
                          Shipping to:{" "}
                          <span className="font-semibold">{state.country}</span>
                        </div>
                      )}
                    </div>
                    {p.products.map((pt, j) => (
                      <ShippingProductDisplay
                        key={j}
                        product={pt}
                        state={state}
                        invalidProducts={invalidProducts}
                      />
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <div className="w-[33%] md-lg:w-full sm:mt-3">
              <div className="pl-3 md-lg:pl-0">
                <div className="bg-[var(--store-product-card-bg)] p-3 text-[var(--store-text)] flex flex-col gap-8">
                  <h2 className="text-xl font-bold flex items-center">
                    Order summary <ScrollText className="ml-2" />
                  </h2>
                  <div className="flex justify-between items-center">
                    <span>Items Total</span>
                    <span> {paymentQuote ? money(paymentQuote.merchants.reduce((sum, m) => sum + m.goodsMinor, 0)) : formatCurrency(itemsTotal, currencyCode, currencyCode)}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>Shipping Fee</span>
                    <span>{paymentQuote ? money(paymentQuote.merchants.reduce((sum, m) => sum + m.shippingMinor, 0)) : formatCurrency(totalShippingCost, currencyCode, currencyCode)}</span>
                  </div>
                  <div className="flex justify-between items-center font-bold">
                    <span>Total Payment</span>
                    <span>{paymentQuote ? money(paymentQuote.totalMinor) : formatCurrency(itemsTotal + totalShippingCost, currencyCode, currencyCode)}</span>
                  </div>
                  <div className="space-y-3 text-sm">
                    <p>Pay directly to each merchant by bank transfer. Each payment is confirmed by that merchant.</p>
                    {quoteError && <p role="alert">{quoteError}</p>}
                    {paymentQuote?.merchants.map(merchant => <div key={merchant.sellerId} className="border-t py-2"><strong>{merchant.shopName}</strong><p>Items {money(merchant.goodsMinor)} · Delivery {money(merchant.shippingMinor)}</p><p className="font-semibold">Transfer {money(merchant.totalMinor)}</p></div>)}
                    {paymentQuote && <p className="font-bold">Total to transfer: {money(paymentQuote.totalMinor)}</p>}
                    {state.country && <button type="button" className="underline" onClick={() => setQuoteVersion(v => v + 1)}>Refresh transfer totals</button>}
                    <p className="text-xs">The NGN transfer totals above are the final checkout amounts. Quotes are valid for 10 minutes.</p>
                  </div>
                  <Button
                    onClick={placeOrder}
                    disabled={placing || !paymentQuote || !res || invalidProducts.length > 0}
                    className={`px-5 py-[6px] rounded-full ${res && invalidProducts.length === 0
                      ? "bg-[var(--store-button-bg)] text-[var(--store-button-text)] hover:bg-[var(--store-button-bg)] hover:opacity-90"
                      : "cursor-not-allowed opacity-50"
                      } text-sm uppercase`}
                  >
                    {placing ? "Creating your order…" : "Continue to payment"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {!isStoreMode && <Footer />}

      {/* Shipping Not Available Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-[var(--store-card-bg)] text-[var(--store-text)] p-6 rounded-lg max-w-md w-full mx-4">
            <div className="flex items-center gap-2 text-red-500 mb-4">
              <AlertTriangle className="h-5 w-5" />
              <h2 className="text-lg font-semibold">Shipping Not Available</h2>
            </div>
            <p className="text-[var(--store-muted)] mb-4">
              Some items in your cart cannot be shipped to {state.country}.
              Please remove these items from your cart or choose a different
              shipping destination.
            </p>
            <div className="flex justify-end">
              <Link to="/cart" state={{ fromStore: location.state?.fromStore }}>
                <Button className="bg-[var(--store-button-bg)] text-[var(--store-button-text)] hover:bg-[var(--store-button-bg)] hover:opacity-90 mr-2">
                  Update Cart
                </Button>
              </Link>
              <Button
                onClick={() => {
                  setShowModal(false);
                  setRes(false);
                }}
                className="bg-[var(--store-button-bg)] text-[var(--store-button-text)] hover:bg-[var(--store-button-bg)] hover:opacity-90"
              >
                Update Shipping Details
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Shipping;
